import { render, staticRenderFns } from "./cfg.vue?vue&type=template&id=05f34676&scoped=true&"
import script from "./cfg.vue?vue&type=script&lang=js&"
export * from "./cfg.vue?vue&type=script&lang=js&"
import style0 from "./cfg.vue?vue&type=style&index=0&id=05f34676&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f34676",
  null
  
)

export default component.exports